import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ActiveFilter,
  ActiveFilterPills,
} from "@/shared/components/common/ActiveFilterPills";
import {
  EntityListFilter,
  EntityListHeaderShell,
} from "@/features/tenantUsers/components";
import { useContentCreatorsListStore } from "@/store";
import { getContentCreatorsListFilterSections } from "../constants/filterConfig";
import { getContentCreatorsListingConfig } from "../constants/listingConfig";

export function ContentCreatorsHeader() {
  const { t } = useTranslation("contentCreators");
  const listingConfig = getContentCreatorsListingConfig(t);
  const listFilterValues = useContentCreatorsListStore(
    (s) => s.listFilterValues,
  );
  const setListFilterValues = useContentCreatorsListStore(
    (s) => s.setListFilterValues,
  );
  const setCurrentPage = useContentCreatorsListStore((s) => s.setPage);
  const searchQuery = useContentCreatorsListStore((s) => s.searchQuery);
  const setSearchQuery = useContentCreatorsListStore((s) => s.setSearchQuery);

  const activeFilters: ActiveFilter[] = useMemo(() => {
    const filters: ActiveFilter[] = [];
    const accountStatus = String(listFilterValues.accountStatus ?? "");
    if (accountStatus) {
      filters.push({
        id: "accountStatus",
        label: t("contentCreators:filter.accountStatus"),
        displayText: accountStatus,
      });
    }
    return filters;
  }, [listFilterValues, t]);

  const handleRemoveFilter = (id: string) => {
    setListFilterValues({ ...listFilterValues, [id]: "" });
    setCurrentPage(1);
  };

  const handleClearAllFilters = () => {
    setListFilterValues({ accountStatus: "" });
    setSearchQuery("");
    setCurrentPage(1);
  };

  return (
    <EntityListHeaderShell
      searchPlaceholder={listingConfig.searchPlaceholder}
      searchValue={searchQuery}
      onSearchChange={setSearchQuery}
      sampleSheetPath={listingConfig.sampleSheetPath}
      bulkUploadPath={listingConfig.bulkUploadPath}
      addPath={listingConfig.addPath}
      addLabel={listingConfig.addLabel}
      filterControl={
        <EntityListFilter
          sections={getContentCreatorsListFilterSections(t)}
          values={listFilterValues}
          onChange={setListFilterValues}
          onApply={() => setCurrentPage(1)}
          activeFilters={activeFilters}
          onRemoveFilter={handleRemoveFilter}
          onClearAllFilters={handleClearAllFilters}
          showPills={false}
        />
      }
      footerContent={
        <ActiveFilterPills
          filters={activeFilters}
          onRemove={handleRemoveFilter}
          onClearAll={handleClearAllFilters}
        />
      }
    />
  );
}
